/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Box, IconButton, Tooltip } from '@mui/material';

import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { deleteCard } from 'js/actions/onOffAcrtions';
import { Delete, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import getToken from 'helpers/auth';

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

export default function PowerFactorTable({ meterId }) {
  const dispatch = useDispatch();
  const [fps, setFps] = useState([]);
  const navigate = useNavigate();

  const handleUpdate = (rowData) => {
    navigate(`/editPowerFactor/${meterId}/${rowData.id}`, { hw: rowData });
  };

  const [state, setState] = useState({
    columns: [
      { headerName: 'Identificador', field: 'id', flex: 1 },
      { headerName: 'Nombre', field: 'name', flex: 1 },
      { headerName: 'Descripción', field: 'description', flex: 1 },
      {
        headerName: 'Ade',
        field: 'ade',
        flex: 1,
        renderCell: (rowData) => {
          if (rowData.row.ade == 1) {
            return 'ADE1';
          } else if (rowData.row.ade == 2) {
            return 'ADE2';
          } else {
            return '';
          }
        },
      },
      {
        headerName: 'Action',
        flex: 1,
        renderCell: (rowData) => (
          <>
            <Tooltip title="Eliminar FP">
              <IconButton onClick={() => deleteFP(rowData.row.id)}>
                <Delete />
              </IconButton>
            </Tooltip>

            <Tooltip title="Editar FP">
              <IconButton onClick={() => handleUpdate(rowData.row)}>
                <Edit />
              </IconButton>
            </Tooltip>
          </>
        ),
      },
    ],
  });

  const deleteFP = (fpId) => {
    dispatch(deleteCard(fpId));
  };

  useEffect(() => {
    dispatch(loadFps());
  }, []);

  useEffect(() => {
    setState({ ...state, data: fps });
  }, [fps]);

  const loadFps = () => {
    return async () => {
      axios
        .get(
          `https://api.metimur.mx/api/meter/${meterId}/fp`,

          {
            headers: { Authorization: 'Bearer ' + getToken() },
          }
        )
        .then((response) => {
          setFps(response.data.data);
        })
        .catch(function (error) {
          console.log('error:' + error);
        });
    };
  };

  return (
    <DataGrid
      rows={state.data}
      columns={state.columns}
      // Deshabilitar la seleccion de filas
      rowSelection={false}
      // Configuración de tabla
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 5, // Tamaño de la página
          },
        },
      }}
      slots={{ toolbar: QuickSearchToolbar }} // Usa el componente QuickSearchToolbar para la barra de búsqueda
      sx={{
        pt: 2,
        pb: 2,
        borderRadius: 2,
        boxShadow: 3,
        backgroundColor: 'background.paper', // Color de fondo de la tabla
        border: '1px solid',
        borderColor: 'divider',
        '& .MuiDataGrid-root': {
          border: 'none', // Quitar borde de la tabla
        },
        '& .MuiDataGrid-cell': {
          borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
          maxHeight: '60px', // Altura máxima de las celdas
        },
        '& .MuiDataGrid-columnHeaders': {
          borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados de columna
        },
        '& .MuiDataGrid-row': {
          borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
          maxHeight: '60px', // Altura máxima de las filas
        },
      }}
    />
  );
}
